export default {
    computed: {
        mostRecentLists() {
            if (this.lists.length == 0) return []
            return this.lists.slice(0, 3)
        },

        allLists() {
            if (this.lists.length == 0) return []
            return this.lists.slice(3, (this.lists.length - 3))
        }
    }
}
